import StepFiveIcon from './component.jsx'
export default StepFiveIcon
